<script>
import TemplatesPicker from './TemplatesPicker.vue';
import TemplateParser from './TemplateParser.vue';
import WhatsappChannel from 'dashboard/api/channel/whatsappChannel';
import { useAlert } from 'dashboard/composables';
export default {
  components: {
    TemplatesPicker,
    TemplateParser,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inboxId: {
      type: Number,
      default: undefined,
    },
  },
  emits: ['onSend', 'cancel', 'update:show'],
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    modalHeaderContent() {
      return this.selectedWaTemplate
        ? this.$t('WHATSAPP_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
            templateName: this.selectedWaTemplate.name,
          })
        : this.$t('WHATSAPP_TEMPLATES.MODAL.SUBTITLE');
    },
  },
  methods: {
    pickTemplate(template) {
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.selectedWaTemplate = null;
    },
    async onSendMessage(message) {
      // Validação de limites antes do envio de template
      try {
        const { data: limits } = await WhatsappChannel.getTemplateMessageLimits();
        const currentUser = this.$store.getters['getCurrentUser'];
        // Determinar role baseado no tipo do usuário (mesma lógica do backend)
        const isSuperAdmin = currentUser?.type === 'SuperAdmin';
        const roleKey = isSuperAdmin ? 'super_admin' : 'manager';
        const totalRemaining = limits?.remaining?.total ?? 0;
        const roleRemaining = limits?.remaining?.[roleKey] ?? 0;
        if (totalRemaining <= 0 || roleRemaining <= 0) {
          useAlert(this.$t('CAMPAIGN.WHATSAPP.CREATE.FORM.API.ERROR_LIMIT_REACHED'));
          return;
        }
      } catch (e) {
        // Se falhar a verificação, segue o fluxo sem bloquear
      }

      this.$emit('onSend', message);
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <woot-modal v-model:show="localShow" :on-close="onClose" size="modal-big">
    <woot-modal-header
      :header-title="$t('WHATSAPP_TEMPLATES.MODAL.TITLE')"
      :header-content="modalHeaderContent"
    />
    <div class="row modal-content">
      <TemplatesPicker
        v-if="!selectedWaTemplate"
        :inbox-id="inboxId"
        @on-select="pickTemplate"
      />
      <TemplateParser
        v-else
        :template="selectedWaTemplate"
        @reset-template="onResetTemplate"
        @send-message="onSendMessage"
      />
    </div>
  </woot-modal>
</template>

<style scoped>
.modal-content {
  padding: 1.5625rem 2rem;
}
</style>
